import { useEffect, useState } from 'react';
import { storageUrl } from '../firebase';

interface TArg {
  content: string | null;
  activeAnchor: HTMLElement | null;
}

const TooltipMapImage = ({ urlin }: { urlin: string }) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setUrl(img.src);
    };
    img.src = storageUrl(urlin);
  }, [urlin]);

  if (!url) return <></>;

  return <img src={storageUrl(url)} alt="floorplanpicture"></img>;
};

const TooltipMap = ({ activeAnchor }: TArg) => {
  const picture = activeAnchor?.getAttribute('data-tooltip-picture') || '';
  const name = activeAnchor?.getAttribute('data-tooltip-name') || '';

  return (
    <div className="w-60">
      <div className="p-2">
        <TooltipMapImage urlin={picture} />
      </div>
      <div className="mb-3 text-center text-base">{name}</div>
    </div>
  );
};

export default TooltipMap;
